// Terminal screen for both the guest and account-holder paths — this
// task's scope ends here (no status tracker yet, see PROGRESS.md). Shows
// the real ref_no from the server response (never a client-guessed number —
// proforma/request numbering is allocated server-side, root CLAUDE.md rule
// 4) and a short, concrete "what happens next" line rather than a bare
// "success" message.
//
// `trackingToken` (confirmation-screen task) — guest-only, optional: only
// guestService.submitGuestRequest's response carries one
// (guestService.markOwnGuestSubmissionVerified has already pre-opened that
// one token's OTP gate in the same request, so this link reaches the real
// tracking view immediately, no second code — see that function's own
// comment for why that isn't a weakening of the gate). pages/
// RequestFormPage.jsx (account-holder path) never passes this prop; its own
// confirmation renders exactly as before — that path already has an
// always-available /track list, so there is nothing to add here for it.
// /proforma/:token is checked (see this task's PROGRESS.md entry) to render
// a real "received, awaiting pricing" skeleton rather than an empty page in
// this exact pre-quotation state, so this is never a dead-end link.
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext.jsx';
import styles from './RequestConfirmation.module.css';

export default function RequestConfirmation({ refNo, trackingToken, onNewRequest }) {
  const { t } = useLanguage();

  return (
    <div className={styles.wrapper} role="status">
      <p className={styles.title}>{t('portal.confirmation.title')}</p>

      <div className={styles.refBlock}>
        <span className={styles.refLabel}>{t('portal.confirmation.refNoLabel')}</span>
        <span className={`${styles.refNo} tabularNums`}>{refNo}</span>
      </div>

      <p className={styles.whatNext}>{t('portal.confirmation.whatNext')}</p>

      {trackingToken && (
        <>
          <Link to={`/proforma/${trackingToken}`} className={styles.trackButton}>
            {t('portal.confirmation.trackThisRequest')}
          </Link>
          <p className={styles.saveRefHint}>{t('portal.confirmation.saveRefHint')}</p>
        </>
      )}

      <button type="button" className={styles.newRequestButton} onClick={onNewRequest}>
        {t('portal.confirmation.newRequest')}
      </button>
    </div>
  );
}
